// extracted by mini-css-extract-plugin
export default {"FormWrapper":"Interest_FormWrapper__HI3e2"};